import { render, staticRenderFns } from "./Factorypricing.vue?vue&type=template&id=5157b35d&scoped=true"
import script from "./Factorypricing.vue?vue&type=script&lang=js"
export * from "./Factorypricing.vue?vue&type=script&lang=js"
import style0 from "./Factorypricing.vue?vue&type=style&index=0&id=5157b35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157b35d",
  null
  
)

export default component.exports